import { Card } from '@/components/ui/Card';
import { Skeleton } from '@/components/ui/Skeleton';
import { AlertTriangle } from 'lucide-react';
import type { SICAttentionItem } from '@/types/sic-report.types';

interface Props {
    items: SICAttentionItem[];
    isLoading: boolean;
    onClickAccount?: (creditId: string) => void;
}

function formatTimestamp(iso: string): string {
    return new Date(iso).toLocaleString('es-MX', { dateStyle: 'short', timeStyle: 'short' });
}

export function SICAttentionCard({ items, isLoading, onClickAccount }: Props) {
    if (isLoading) {
        return (
            <Card title="Cuentas con datos pendientes" description="Cuentas con REJECTED recurrente que requieren correccion">
                <Skeleton className="h-24" />
            </Card>
        );
    }

    if (items.length === 0) {
        return (
            <Card title="Cuentas con datos pendientes" description="Cuentas con REJECTED recurrente que requieren correccion">
                <p className="text-sm text-slate-400">Sin cuentas que requieran atención. ✓</p>
            </Card>
        );
    }

    return (
        <Card title="Cuentas con datos pendientes" description="Cuentas con REJECTED recurrente que requieren correccion">
            <div className="flex items-center gap-2 text-sm text-amber-400 mb-3">
                <AlertTriangle size={16} />
                <span>{items.length} cuenta{items.length > 1 ? 's' : ''} con REJECTED recurrente</span>
            </div>
            <div className="overflow-x-auto">
                <table className="w-full text-sm">
                    <thead>
                        <tr className="border-b border-slate-700 text-xs uppercase tracking-wider text-slate-500">
                            <th className="pb-2 text-left font-normal">Crédito</th>
                            <th className="pb-2 text-left font-normal">Motivo</th>
                            <th className="pb-2 text-left font-normal">Último intento</th>
                            <th className="pb-2 text-right font-normal">Acción</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((item) => (
                            <tr key={item.credit_id} className="border-b border-slate-800/50">
                                <td className="py-2 font-mono text-xs text-slate-300">{item.credit_id}</td>
                                <td className="py-2 text-slate-200">{item.error_message ?? item.error_code ?? '—'}</td>
                                <td className="py-2 text-slate-400">{formatTimestamp(item.sent_at)}</td>
                                <td className="py-2 text-right">
                                    {onClickAccount && (
                                        <button
                                            onClick={() => onClickAccount(item.credit_id)}
                                            className="text-xs text-blue-400 hover:text-blue-300 underline"
                                        >
                                            Ir al expediente
                                        </button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </Card>
    );
}
